import React from 'react'

import './report.scss'
import { StrategyType, ReportStatus, PageSpeedDigest } from './common'

import { RouteComponentProps } from 'react-router'
import QueryString from 'querystring'
import Axios from 'axios'
import { Card } from './Card'
import { ContactForm } from './ContactForm'
import { DynamicReport } from './DynamicReport'
import { ProgressBar } from 'react-bootstrap'

interface ReportProps extends RouteComponentProps<{}> {
}

interface ReportState {
  url: string,
  strategy: StrategyType
  status: ReportStatus
  digest: PageSpeedDigest,
  errorMessage: string,
}

export class Report extends React.Component<ReportProps, ReportState> {
  constructor(props: ReportProps) {
    super(props)
    this.state = {
      url: 'sample',
      strategy: 'mobile',
      status: 'processing',
      digest: new PageSpeedDigest(),
      errorMessage: '',
    }

    this.cancelProcessing = this.cancelProcessing.bind(this)
  }

  async loadPageSpeedDigest() {
    this.setState({ status: 'processing' })
    try {
      const res = await Axios.get('https://v1.util.simulate.site/pagespeed-insights-digest', {
        params: {
          url: this.state.url,
          strategy: this.state.strategy
        }
      })

      await this.setState({ status: 'done', digest: new PageSpeedDigest(res.data) })
    } catch (ex) {
      this.setState({ status: 'error', errorMessage: ex.message })
    }
  }

  async componentDidMount() {
    const qs = QueryString.decode(this.props.location.search.replace(/^\?/, ''))
    await this.setState({ url: (qs.url || 'sample').toString(), strategy: (qs.strategy || 'mobile').toString() as StrategyType })
    await this.loadPageSpeedDigest()
  }

  cancelProcessing() {
    this.props.history.push({
      pathname: '/'
    })
  }

  get rank() {
    return Math.round((1 - this.state.digest.score) * 100)
  }

  public renderLoading() {
    return (
      <>
        <p className="text-muted">PageSpeed Insights APIを実行しています。
        <a href={`${process.env.PUBLIC_URL}`} className="ml-2" onClick={this.cancelProcessing}>キャンセル</a>
        </p>
        <ProgressBar animated={true} now={100} />
      </>
    )
  }

  public renderError() {
    return (
      <div className="alert alert-danger">{this.state.errorMessage}</div>
    )
  }

  public renderReport() {
    return (
      <>
        <p>
          <a href={`${process.env.PUBLIC_URL}`} className="btn btn-secondary">← 他のページのレポートを作成</a>
        </p>
        <Card title={`PageSpeed Insights 試験対策 ${this.state.url}`}>
          <DynamicReport digest={this.state.digest}></DynamicReport>
        </Card>
        <ContactForm></ContactForm>
      </>
    )
  }

  public render() {
    return (
      <div className="container">
        {this.state.status === 'done' ? this.renderReport() : this.state.status === 'error' ? this.renderError() : this.renderLoading()}
      </div>
    )
  }
}
